import { render, staticRenderFns } from "./productsRecord.vue?vue&type=template&id=dcfdb1e2&"
import script from "./productsRecord.vue?vue&type=script&lang=js&"
export * from "./productsRecord.vue?vue&type=script&lang=js&"
import style0 from "./productsRecord.vue?vue&type=style&index=0&id=dcfdb1e2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcfdb1e2')) {
      api.createRecord('dcfdb1e2', component.options)
    } else {
      api.reload('dcfdb1e2', component.options)
    }
    module.hot.accept("./productsRecord.vue?vue&type=template&id=dcfdb1e2&", function () {
      api.rerender('dcfdb1e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/products/productsRecord.vue"
export default component.exports